import { Component, EventEmitter, inject, Output } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Location, NgClass, NgIf, PlatformLocation } from '@angular/common';
import { SafeHtmlSvgPipe } from '../../_services/svg-pipe/safe-html-svg.pipe';
import { MenuItem } from '../../models/users.model';
import { Subscription } from 'rxjs';
import { HttpServiceService } from '../../services/http-service.service';
import { USER_PERMISSIONS } from '../../app.constants';
import { LocalStorageService } from '../../services/local-storage.service';
@Component({
  selector: 'app-sidebar',
  imports: [NgClass, RouterLink, SafeHtmlSvgPipe, NgIf],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent {
  @Output() newTitleEvent = new EventEmitter<{ title: string }>(); // DashBoard Title
  @Output() mouseHoverEvent = new EventEmitter<string>(); // Data pass Admin page

  email: string = '';
  activeToggle: string = '';
  localData: any = '';
  elementValue: any = '';
  currentHref: string = "";
  public isVisited = false;
  private httpService = inject(HttpServiceService);
  private localService = inject(LocalStorageService);
  userPermissionsList : any = [];
  constructor(private router: Router, private location: Location, private backLocation: PlatformLocation) {
    router.events.subscribe((val) => {
      if (location.path() != '') {
        this.currentHref = location.path();
      } else {
        this.currentHref = '/index'
      }
    });
    backLocation.onPopState(() => {   // back click get url
      this.handleActiveMenu(window.location.pathname);
    });
    this.userPermissionsList = this.localService.listUserPermissions();
  }

  ngDoCheck(): void {
    this.elementValue = document.body.getAttribute('data-theme-version');
  }

  getActive(menu: any) {     //  side menu manage
    if (this.activeToggle != menu) {
      this.activeToggle = menu;
    } else {
      this.activeToggle = '';
    }
  }
  hoverAdd(val: any) {
    const getStyle = document.body.getAttribute('data-sidebar-style')
    if (getStyle == 'icon-hover') {
      this.mouseHoverEvent.emit(val);
    }
  }
  checkVisited() {
    this.isVisited = !this.isVisited;
  }
  ngOnInit(): void {
    this.elementValue = document.body.getAttribute('data-theme-version');
    this.handleActiveMenu(this.currentHref);
  }

  themeMode(menu: any) {    // dark-light theme set function
    this.activeSubMenu = '';
    localStorage.setItem("data-theme-version", menu);
    this.localData = localStorage.getItem('data-theme-version');
    this.elementValue = this.localData;
    document.body.setAttribute('data-theme-version', this.localData);
  }

  activeMenu: string = "";
  activeSubMenu: string = "";
  activeSubSubMenu: string = "";

  handleActiveMenu(val: any) {
    this.sidebarMenu.map((data: any, ind: any) => {
      if (data.route == val) {
        this.activeMenu = data.title;
      }
      data.subMenu?.map((item: any, ind: any) => {
        if (item.route == val) {
          this.activeMenu = data.title;
          this.activeSubMenu = item.title;
          this.activeSubSubMenu = "";
        }
        item.subsubMenu?.map((item1: any, ind: any) => {
          if (item1.route == val) {
            this.activeMenu = data.title;
            this.activeSubMenu = item.title;
            this.activeSubSubMenu = item1.title
          }
        })
      })
    })
    this.newTitleEvent.emit({ title: this.activeMenu });
  }

  handleMenu(val: any) {
    if (this.activeMenu == "Chat") {
      this.activeMenu = val;
    } else {
      if (this.activeMenu == val) {
        this.activeMenu = "";
      } else {
        this.activeMenu = val;
      }
    }
  }
  handleActiveSubMenu(val: any) {
    if (this.activeSubMenu == val) {
      this.activeSubMenu = "";
    } else {
      this.activeSubMenu = val;
    }
  }


  sidebarMenu: MenuItem[] = [
    {

      title: "Dashboard",
      icon: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.37121 10.2017V17.0619" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.0382 6.91913V17.0618" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.6285 13.8268V17.0619" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
      route: '/admin',
      permissionName : USER_PERMISSIONS.REPORTS.REPORTS_OWNER_PAGE
    },
    {
      title: "Users",
      icon: `<svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M8.79222 13.9396C12.1738 13.9396 15.0641 14.452 15.0641 16.4989C15.0641 18.5458 12.1931 19.0729 8.79222 19.0729C5.40972 19.0729 2.52039 18.5651 2.52039 16.5172C2.52039 14.4694 5.39047 13.9396 8.79222 13.9396Z" stroke="#888888" stroke-linecap="round" stroke-linejoin="round"/>
								<path fill-rule="evenodd" clip-rule="evenodd" d="M8.79223 11.0182C6.57206 11.0182 4.77173 9.21874 4.77173 6.99857C4.77173 4.7784 6.57206 2.97898 8.79223 2.97898C11.0115 2.97898 12.8118 4.7784 12.8118 6.99857C12.8201 9.21049 11.0326 11.0099 8.82064 11.0182H8.79223Z" stroke="#888888" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M15.1095 9.9748C16.5771 9.76855 17.7073 8.50905 17.7101 6.98464C17.7101 5.48222 16.6147 4.23555 15.1782 3.99997" stroke="#888888" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M17.0458 13.5045C18.4675 13.7163 19.4603 14.2149 19.4603 15.2416C19.4603 15.9483 18.9928 16.4067 18.2374 16.6936" stroke="#888888" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>`,
      route: "/admin/users",
      permissionName : USER_PERMISSIONS.USERS.USERS_PAGE
    },
    {
      title: "Properties",
      icon: `<svg _ngcontent-ng-c3933085341="" width="18" height="18" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" class="me-2"><path _ngcontent-ng-c3933085341="" d="M2.125 6.375L8.5 1.41667L14.875 6.375V14.1667C14.875 14.5424 14.7257 14.9027 14.4601 15.1684C14.1944 15.4341 13.8341 15.5833 13.4583 15.5833H3.54167C3.16594 15.5833 2.80561 15.4341 2.53993 15.1684C2.27426 14.9027 2.125 14.5424 2.125 14.1667V6.375Z" stroke="#888888" stroke-linecap="round" stroke-linejoin="round"></path><path _ngcontent-ng-c3933085341="" d="M6.375 15.5833V8.5H10.625V15.5833" stroke="#888888" stroke-linecap="round" stroke-linejoin="round"></path></svg>`,
      route: "/admin/properties/properties-list",
      permissionName : USER_PERMISSIONS.PROPERTIES.PROPERTIES_PAGE
    },
    {
      title: "Owners",
      icon: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.8877 10.8967C19.2827 10.7007 20.3567 9.50467 20.3597 8.05567C20.3597 6.62767 19.3187 5.44367 17.9537 5.21967" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.7285 14.2503C21.0795 14.4523 22.0225 14.9253 22.0225 15.9003C22.0225 16.5713 21.5785 17.0073 20.8605 17.2813" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8867 14.6638C8.67273 14.6638 5.92773 15.1508 5.92773 17.0958C5.92773 19.0398 8.65573 19.5408 11.8867 19.5408C15.1007 19.5408 17.8447 19.0588 17.8447 17.1128C17.8447 15.1668 15.1177 14.6638 11.8867 14.6638Z" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8869 11.8879C13.9959 11.8879 15.7059 10.1789 15.7059 8.06888C15.7059 5.95988 13.9959 4.24988 11.8869 4.24988C9.7779 4.24988 8.0679 5.95988 8.0679 8.06888C8.0599 10.1709 9.7569 11.8809 11.8589 11.8879H11.8869Z" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.88509 10.8967C4.48909 10.7007 3.41609 9.50467 3.41309 8.05567C3.41309 6.62767 4.45409 5.44367 5.81909 5.21967" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.044 14.2503C2.693 14.4523 1.75 14.9253 1.75 15.9003C1.75 16.5713 2.194 17.0073 2.912 17.2813" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
      route: "/admin/owners",
      permissionName : USER_PERMISSIONS.OWNERS.OWNERS_PAGE
    },
    {
      title: "Tenants",
      icon: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.8877 10.8967C19.2827 10.7007 20.3567 9.50467 20.3597 8.05567C20.3597 6.62767 19.3187 5.44367 17.9537 5.21967" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.7285 14.2503C21.0795 14.4523 22.0225 14.9253 22.0225 15.9003C22.0225 16.5713 21.5785 17.0073 20.8605 17.2813" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8867 14.6638C8.67273 14.6638 5.92773 15.1508 5.92773 17.0958C5.92773 19.0398 8.65573 19.5408 11.8867 19.5408C15.1007 19.5408 17.8447 19.0588 17.8447 17.1128C17.8447 15.1668 15.1177 14.6638 11.8867 14.6638Z" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8869 11.8879C13.9959 11.8879 15.7059 10.1789 15.7059 8.06888C15.7059 5.95988 13.9959 4.24988 11.8869 4.24988C9.7779 4.24988 8.0679 5.95988 8.0679 8.06888C8.0599 10.1709 9.7569 11.8809 11.8589 11.8879H11.8869Z" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.88509 10.8967C4.48909 10.7007 3.41609 9.50467 3.41309 8.05567C3.41309 6.62767 4.45409 5.44367 5.81909 5.21967" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.044 14.2503C2.693 14.4523 1.75 14.9253 1.75 15.9003C1.75 16.5713 2.194 17.0073 2.912 17.2813" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
      route: "/admin/tenants",
      permissionName : USER_PERMISSIONS.TENANTS.TENANTS_PAGE
    },
    {
      title: "Inspections",
      icon: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.9951 16.6768V14.1398" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.19 5.3302C19.88 5.3302 21.24 6.7002 21.24 8.3902V11.8302C18.78 13.2702 15.53 14.1402 11.99 14.1402C8.45 14.1402 5.21 13.2702 2.75 11.8302V8.3802C2.75 6.6902 4.12 5.3302 5.81 5.3302H18.19Z" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.4951 5.32582V4.95982C15.4951 3.73982 14.5051 2.74982 13.2851 2.74982H10.7051C9.48512 2.74982 8.49512 3.73982 8.49512 4.95982V5.32582" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.77441 15.483L2.96341 17.992C3.09141 19.683 4.50041 20.99 6.19541 20.99H17.7944C19.4894 20.99 20.8984 19.683 21.0264 17.992L21.2154 15.483" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
      route: "/admin/inspections",
      permissionName : USER_PERMISSIONS.INSPECTIONS.INSPECTION_PAGE
    },
    {
      title: "Service Requests",
      icon: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M17.857 20.4171C19.73 20.4171 21.249 18.8991 21.25 17.0261V17.0241V14.3241C20.013 14.3241 19.011 13.3221 19.01 12.0851C19.01 10.8491 20.012 9.84612 21.249 9.84612H21.25V7.14612C21.252 5.27212 19.735 3.75212 17.862 3.75012H17.856H6.144C4.27 3.75012 2.751 5.26812 2.75 7.14212V7.14312V9.93312C3.944 9.89112 4.945 10.8251 4.987 12.0191C4.988 12.0411 4.989 12.0631 4.989 12.0851C4.99 13.3201 3.991 14.3221 2.756 14.3241H2.75V17.0241C2.749 18.8971 4.268 20.4171 6.141 20.4171H6.142H17.857Z" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.3711 9.06309L12.9871 10.3101C13.0471 10.4321 13.1631 10.5171 13.2981 10.5371L14.6751 10.7381C15.0161 10.7881 15.1511 11.2061 14.9051 11.4451L13.9091 12.4151C13.8111 12.5101 13.7671 12.6471 13.7891 12.7821L14.0241 14.1521C14.0821 14.4911 13.7271 14.7491 13.4231 14.5891L12.1921 13.9421C12.0711 13.8781 11.9271 13.8781 11.8061 13.9421L10.5761 14.5891C10.2711 14.7491 9.91609 14.4911 9.97409 14.1521L10.2091 12.7821C10.2321 12.6471 10.1871 12.5101 10.0891 12.4151L9.09409 11.4451C8.84809 11.2061 8.98309 10.7881 9.32309 10.7381L10.7001 10.5371C10.8351 10.5171 10.9521 10.4321 11.0121 10.3101L11.6271 9.06309C11.7791 8.75509 12.2191 8.75509 12.3711 9.06309Z" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`,
      route: "/admin/service-requests",
      permissionName : USER_PERMISSIONS.SERVICE_REQUEST.SERVICE_REQUEST_PAGE
    },
    {
      title: "Enquiries",
      icon: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 2h20v14H6l-4 4V2z" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
      route: "/admin/enquiries",
      permissionName: USER_PERMISSIONS.ENQUIRIES.ENQUIRY_PAGE
    },
    {
      title: "Leads",
      icon: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="8.5" cy="7" r="4" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20 8v6M23 11h-6" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
      route: "/admin/leads",
      permissionName: USER_PERMISSIONS.LEADS.LEADS_PAGE
    },
    {
      title: "Tasks",
      icon: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 11l3 3L22 4" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
      subMenu: [
        {
          title: "Team tasks",
          route: "/admin/tasks",
          permissionName: USER_PERMISSIONS.TASKS.TASKS_PAGE
        },
        {
          title: "Daily activity",
          route: "/admin/tasks/activity",
          permissionName: USER_PERMISSIONS.TASKS.TASKS_REPORTS
        },
        {
          title: "Recurring tasks",
          route: "/admin/tasks/recurrences",
          permissionName: USER_PERMISSIONS.TASKS.TASKS_MANAGE_TEMPLATES
        }
      ],
      permissions: [
        USER_PERMISSIONS.TASKS.TASKS_PAGE,
        USER_PERMISSIONS.TASKS.TASKS_REPORTS,
        USER_PERMISSIONS.TASKS.TASKS_MANAGE_TEMPLATES
      ]
    },
    {
      title: "Bank Accounts",
      icon: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 21h18M3 10h18M5 6l7-3 7 3M4 10v11M20 10v11M8 14v3M12 14v3M16 14v3" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
      route: "/admin/bank-accounts",
      permissionName: USER_PERMISSIONS.BANK_ACCOUNTS.BANK_ACCOUNTS_PAGE
    },
    {
      title: "Reports",
      icon: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.37121 10.2017V17.0619" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.0382 6.91913V17.0618" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.6285 13.8268V17.0619" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
      subMenu: [
        {
          title: "Inspections",
          route: "/admin/reports/inspections",
          permissionName: USER_PERMISSIONS.REPORTS.REPORTS_INSPECTION_PAGE
        },
        {
          title: "Accounts",
          route: "/admin/reports/accounts",
          permissionName: USER_PERMISSIONS.REPORTS.REPORTS_ACCOUNTS_PAGE
        },
        {
          title: "Properties",
          route: "/admin/reports/properties",
          permissionName: USER_PERMISSIONS.REPORTS.REPORTS_PROPERTIES_PAGE
        },
        {
          title: "Leases",
          route: "/admin/reports/leases",
          permissionName: USER_PERMISSIONS.REPORTS.REPORTS_LEASES_PAGE
        },
        {
          title: "Enquiries",
          route: "/admin/reports/enquiries",
          permissionName: USER_PERMISSIONS.REPORTS.REPORTS_ENQUIRIES_PAGE
        },
        {
          title: "Leads",
          route: "/admin/reports/leads",
          permissionName: USER_PERMISSIONS.REPORTS.REPORTS_LEADS_PAGE
        },
        {
          title: "Service Requests",
          route: "/admin/reports/service-requests",
          permissionName: USER_PERMISSIONS.REPORTS.REPORTS_SERVICE_REQUESTS_PAGE
        },
        {
          title: "Owner Accounts",
          route: "/admin/reports/owner-reports",
          permissionName: USER_PERMISSIONS.REPORTS.REPORTS_OWNER_PAGE
        },
        {
          title: "Company Accounts",
          route: "/admin/reports/company-reports",
          permissionName: USER_PERMISSIONS.REPORTS.REPORTS_COMPANY_PAGE
        }
      ],
      permissions : [
        USER_PERMISSIONS.REPORTS.REPORTS_PAGE,
        USER_PERMISSIONS.REPORTS.REPORTS_INSPECTION_PAGE,
        USER_PERMISSIONS.REPORTS.REPORTS_ACCOUNTS_PAGE,
        USER_PERMISSIONS.REPORTS.REPORTS_PROPERTIES_PAGE,
        USER_PERMISSIONS.REPORTS.REPORTS_LEASES_PAGE,
        USER_PERMISSIONS.REPORTS.REPORTS_ENQUIRIES_PAGE,
        USER_PERMISSIONS.REPORTS.REPORTS_LEADS_PAGE,
        USER_PERMISSIONS.REPORTS.REPORTS_SERVICE_REQUESTS_PAGE,
        USER_PERMISSIONS.REPORTS.REPORTS_OWNER_PAGE,
        USER_PERMISSIONS.REPORTS.REPORTS_COMPANY_PAGE
      ]

    },
    {
      title: "Notifications",
      icon: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 17.8476C17.6392 17.8476 20.2481 17.1242 20.5 14.2205C20.5 11.3188 18.6812 11.5054 18.6812 7.94511C18.6812 5.16414 16.0452 2 12 2C7.95477 2 5.31885 5.16414 5.31885 7.94511C5.31885 11.5054 3.5 11.3188 3.5 14.2205C3.75295 17.1352 6.36177 17.8476 12 17.8476Z" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.3889 20.8572C13.0247 22.372 10.8967 22.3899 9.51953 20.8572" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
      route: "/admin/create-notifications",
      permissionName : USER_PERMISSIONS.NOTIFICATIONS.NOTIFICATIONS_PAGE
    },
    {
      title: "Bill Categories",
      icon: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<rect x="9" y="3" width="6" height="4" rx="1" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9 12h6M9 16h4" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
      route: "/admin/bill-categories",
      permissionName : USER_PERMISSIONS.BILL_CATEGORIES.BILL_CATEGORIES_PAGE
    },
    {
      title: "Items",
      icon: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2Z" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<line x1="12" y1="12" x2="12" y2="16" stroke="#888888" stroke-width="1.5" stroke-linecap="round"/>
<line x1="10" y1="14" x2="14" y2="14" stroke="#888888" stroke-width="1.5" stroke-linecap="round"/>
</svg>`,
      route: "/admin/items",
      permissionName : USER_PERMISSIONS.ITEMS.ITEMS_PAGE
    },
    {
      title: "Templates",
      icon: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14 2v6h6" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9 13h6M9 17h4" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
      route: "/admin/templates",
      permissionName: USER_PERMISSIONS.TEMPLATES.TEMPLATES_PAGE
    },
    {
      title: "Assign Permissions",
      icon: `<svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.986 14.0673C7.4407 14.0673 4.41309 14.6034 4.41309 16.7501C4.41309 18.8969 7.4215 19.4521 10.986 19.4521C14.5313 19.4521 17.5581 18.9152 17.5581 16.7693C17.5581 14.6234 14.5505 14.0673 10.986 14.0673Z" stroke="#888888" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.986 11.0054C13.3126 11.0054 15.1983 9.11881 15.1983 6.79223C15.1983 4.46564 13.3126 2.57993 10.986 2.57993C8.65944 2.57993 6.77285 4.46564 6.77285 6.79223C6.76499 9.11096 8.63849 10.9975 10.9563 11.0054H10.986Z" stroke="#888888" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>`,
      route: "/admin/assign_permissions",
      permissionName : USER_PERMISSIONS.PERMISSIONS.PERMISSIONS_PAGE
    },
  ];

  checkUserPermission(permissionName : string | undefined){
    return this.userPermissionsList.includes(permissionName);
  }

  checkAtleastOneUserPermission(permissions : any){
    return permissions.some((p: any) => this.userPermissionsList.includes(p));
  }

}
